// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
export const arrayify_enum = (e) => [...Object.values(e).filter((k) => typeof k === "string")];
